<div class="flex flex-col w-full justify-center items-center bg-toolbar-background">
  <div class="flex flex-col max-w-lg w-full">
    <div class="w-full flex items-center overflow-hidden">
      <button *ngIf="!isCatalog" (click)="onGoBackClicked()" mat-icon-button aria-label="Back">
        <mat-icon svgIcon="ph-regular-caret-left" class="text-title"></mat-icon>
      </button>
      <ng-container *ngIf="!isCatalog">
        <span class="text-title text-center text-xl font-bold flex-1"> {{ title | translate }} </span>
      </ng-container>
      <ng-container *ngIf="isCatalog">
        <div class="w-full flex flex-wrap items-center justify-between text-wrap">
          <span class="text-title text-left text-xl font-bold"> {{ title | translate }} </span>
          <span class="flex-1"></span>

          <div class="flex flex-col items-start max-w-40 box-content" *ngIf="balance > 0 && !isMixBenefitType()">
            <span class="text-xs text-default-gray">{{ 'components.catalog.balance.title' | translate }}:</span>
            <button
              mat-flat-button
              color="accent"
              class="w-full"
              (click)="onBalancePressed()"
              [class.cursor-default]="!isBalanceRechargable()">
              <mat-icon svgIcon="ph-regular-wallet"></mat-icon>
              <span>{{ balance | currencyClp:(!isPointsBenefitType()) }}</span>
              <mat-icon *ngIf="isBalanceRechargable()" svgIcon="ph-regular-plus" class="icon-xxsm ml-1"></mat-icon>
            </button>
            <span *ngIf="isBalanceRechargable()" class="text-xs text-light-gray mt-0.5 opacity-80 text-center">
              Toca para recargar
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
